"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractTitleFromSlug = exports.extractDateFromSlug = exports.createPostSlug = exports.createSlug = void 0;
const createSlug = (title) => {
    return title
        .toLowerCase()
        .trim()
        .replace(/[\s_]+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
};
exports.createSlug = createSlug;
const createPostSlug = (title, date) => {
    const slug = (0, exports.createSlug)(title);
    if (date) {
        const dateStr = date.toISOString().split('T')[0]; // YYYY-MM-DD
        return `${dateStr}-${slug}`;
    }
    return slug;
};
exports.createPostSlug = createPostSlug;
const extractDateFromSlug = (slug) => {
    const dateMatch = slug.match(/^(\d{4}-\d{2}-\d{2})-/);
    if (dateMatch) {
        return new Date(dateMatch[1]);
    }
    return null;
};
exports.extractDateFromSlug = extractDateFromSlug;
const extractTitleFromSlug = (slug) => {
    // Remove date prefix if present
    const withoutDate = slug.replace(/^\d{4}-\d{2}-\d{2}-/, '');
    // Convert back to title case
    return withoutDate
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
exports.extractTitleFromSlug = extractTitleFromSlug;
